import { IComboBoxOption } from "@fluentui/react";
import { ExperimentType } from "../../Types";
import {
  FilterTypes,
  onComboFilterChange,
} from "../../Shared/FilterComponent/FilterComponent";

const getFilters = (
  items: ExperimentType[],
  appliedFilters: { [key: string]: string[] },
  setFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>,
) => {
  return [
    {
      key: "lastModifiedBy",
      text: "Last Modified By",
      type: FilterTypes.Combobox,
      clearable: true,
      selectedKey: appliedFilters["lastModifiedBy"] || [],
      searchable: true,
      options: Array.from(
        new Set(
          items
            .filter(({ lastModifiedBy }) => lastModifiedBy)
            .map(({ lastModifiedBy }) => lastModifiedBy as string),
        ),
      )
        .sort()
        .map((lastModifiedBy) => ({
          key: lastModifiedBy,
          text: lastModifiedBy,
        })),
      onChange: (_: any, option: IComboBoxOption | undefined) =>
        onComboFilterChange("lastModifiedBy", option, setFilters),
    },
  ];
};

export { getFilters };
